import { NodeVisualComponent } from '@shared/components/d3-visuals/shared/node-visual/node-visual.component';

export const SHARED_VISUALS = [
  NodeVisualComponent,
];
